module.exports = __webpack_public_path__ + "img/claimpucl.5ef7b8e8.svg";